import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { APPLICATION_ALREADY_OPEN } from 'src/app/app.consts';
import { AddApplicationResponseModel } from 'src/app/models/applications.model';
import { VerifyWeakResponse } from 'src/app/models/login.model';
import { LoginApiService } from 'src/app/services/api/login-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { AuthService } from 'src/app/services/auth.service';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { FlowService } from 'src/app/services/flow.service';
import { environment } from 'src/environments/local/environment';
import { handleApiError } from 'src/app/utils/error';

import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../shared/dialog/dialog.component';
import { Overlay } from '@angular/cdk/overlay';
import { Router } from '@angular/router';

@Component({
  selector: 'app-init-app',
  templateUrl: './init-app.component.html',
  styleUrls: ['./init-app.component.scss'],
})
export class InitAppComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean = false;
  showContact = false;
  subs = Array<Subscription>();
  tosLink = environment.tos;
  error = '';

  constructor(
    private basicInfoService: BasicInfoService,
    private translateService: TranslateService,
    private loginApi: LoginApiService,
    private authService: AuthService,
    private applicationService: ApplicationService,
    public flowService: FlowService,
    private dialog: MatDialog,
    private overlay: Overlay,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.verifyWeakAndPostLogin();
  }

  verifyWeakAndPostLogin(): void {
    this.subs.push(
      this.loginApi
        .verifyWeak(
          this.basicInfoService.leadId,
          this.basicInfoService.personNumber
        )
        .pipe(
          mergeMap((response: VerifyWeakResponse) => {
            this.authService.accessToken = response.token;
            return this.basicInfoService.handlePostLogin(
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              this.applicationService.estimatedTurnoverPrev,
              this.applicationService.estimatedMonthlySales
            );
          })
        )
        .subscribe(
          (response: AddApplicationResponseModel) => {
            this.applicationService.populateServiceWithData(response);
            this.applicationService.reason = this.basicInfoService.reason;
            this.flowService.selectFlow(response.flowId);
            this.flowService.goToInitialScreen();
          },
          (error: any) => {
            if (
              error.status === 405 &&
              error.error.message === APPLICATION_ALREADY_OPEN
            ) {
              const redirectUrl = `${environment.summaryRedirectUrl}?jwt=${this.authService.accessToken}`;
              window.location.replace(redirectUrl);
            } else if (
              error.message ===
              this.translateService.instant(
                'global.error.issueFetchingCompanyData.thrownErrorText'
              )
            ) {
              this.openDialog('issueFetchingCompanyData');
            } else {
              this.openDialog('createApplicationFailed');
            }
            this.isLoggedIn = true;
            this.error = handleApiError(error, this.translateService);
            this.router.navigate(['basic-info']);
          }
        )
    );
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }

  openDialog(errorMessage: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      maxWidth: '400px',
      data: {
        title: this.translateService.instant(
          `global.error.${errorMessage}.title`
        ),
        question: this.translateService.instant(
          `global.error.${errorMessage}.content`
        ),
        yes: this.translateService.instant(
          `global.error.${errorMessage}.buttonText`
        ),
        align: 'end',
        backgroundColor: '#f2f2f2',
        icon: 'icon-frown',
      },
      autoFocus: false,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe();
  }
}
